/**
 * The VAV wordmark.
 *
 * `VAV` drawn as three chevrons: the `A` is a `V` turned over, so the mark is
 * one shape repeated and alternating. The `A` has no crossbar - that is
 * deliberate. The middle chevron is always the accent, because it is the vav,
 * the thing joining the two outer forms.
 *
 * This is geometry, not type. Do not rebuild it with a font: the mark has to be
 * identical in every market, and a typeface is not script-neutral. Do not place
 * it next to the app icon either - they say the same thing twice.
 */

interface Props {
  className?: string;
}

/**
 * Stroke colours come from CSS (`--wordmark-outer` / `--wordmark-middle`) rather
 * than from props, so light mode is one media query instead of every caller
 * having to know which ground it is sitting on. The light variant is not a style
 * choice: pewter on a light ground is about 1.3:1 and the shape disappears, so
 * the outer strokes darken to graphite and the accent drops to brass-dim.
 */
export function Wordmark({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 309 121" role="img" aria-label="VAV">
      <g
        transform="translate(10.5,10.5)"
        fill="none"
        strokeWidth={21}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M 0,0   L 38,100  L 76,0" stroke="var(--wordmark-outer)" />
        <path d="M 106,100 L 144,0 L 182,100" stroke="var(--wordmark-middle)" />
        <path d="M 212,0 L 250,100 L 288,0" stroke="var(--wordmark-outer)" />
      </g>
    </svg>
  );
}
